<template>
  <div class="table">
    <div v-for="(item, index) in analysisData" :key="item.name" class="item align">
      <div class="box" :style="`background-color: ${$store.state.colors[index]}`"></div>
      <div class="name oneLine">{{ item.name }}</div>
      <div class="percent number-font">{{ Number((item.value / total) * 100).toFixed(2) }}%</div>
      <div class="sell">{{ label }}</div>
      <div class="sell-number number-font">{{label === '销售额' ? '¥' : ''}}{{ $retainWan(Number(item.value).toFixed(0)) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: { analysisData: Array, total: Number, label: String }
};
</script>

<style lang="less" scoped>
.table {
  border-top: 0.02rem solid #e8e6e6;
  width: 6.9rem;
  margin: 0.2rem auto 0;
  color: #4a4a4a;

  .item {
    border-bottom: 0.02rem solid #e8e6e6;
    height: 0.6rem;

    .box {
      width: 0.1rem;
      height: 0.24rem;
      border-radius: 0.02rem;
    }

    .name {
      width: 2rem;
      margin-left: 0.1rem;
    }

    .percent {
      width: 1.6rem;
    }

    .sell {
      width: 1.6rem;
    }

    .sell-number {
      flex: 1;
      text-align: right;
    }
  }
}
</style>